module.exports = __webpack_public_path__ + "img/switch-guide.15a21cc2.png";